import { useQuery } from "@tanstack/react-query";
import { getAllAcademicYears } from "../../api/apiAcademicYears";
import i18next from "i18next";

export function useGetAcademicYears(page = 1, perPage = 15, filters = {}) {
    const { isLoading, data, error } = useQuery({
        queryKey: ["academicYears", page, perPage, filters, i18next.language],
        queryFn: () => getAllAcademicYears(page, perPage, filters),
        retry: false,
    });

    const academicYears = data?.data?.items || [];
    const meta = data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 };

    return { isLoading, error, academicYears, meta };
}
